import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import FieldDisplay from "src/components/ProjectInstance/components/MainSection/FieldDisplay";
import EditableField from "src/components/ProjectInstance/components/MainSection/EditableField";
import { FORM_NAME } from "src/pages/Sequence/detail";
import { getTimeFromDateTime, getTimeSpans } from "src/utils/common";
import TooltipWrapper from "src/components/Common/TooltipWrapper";
import { DATA_SOURCE } from "src/constant/common";

const MainSection = ({ errors, register, sequenceData, navigationPrompt, setValue }) => {
  const { t } = useTranslation("sequence", "common");

  const getDataSourceValue = (data) => {
    if (!data?.[FORM_NAME.MAIN.DATA_SOURCE]) return "";
    const hostname = data?.instance_info?.[FORM_NAME.MAIN.HOSTNAME] || "";
    if (data?.[FORM_NAME.MAIN.DATA_SOURCE] === DATA_SOURCE.AUTO_SYNCS) {
      return `${t(`detail.${DATA_SOURCE.AUTO_SYNCS}`)}${hostname ? ` (${hostname})` : ""}`;
    }
    if (data?.[FORM_NAME.MAIN.DATA_SOURCE] === DATA_SOURCE.MANUAL_UPLOAD) {
      return `${t(`detail.${DATA_SOURCE.MANUAL_UPLOAD}`)}${hostname ? ` (${hostname})` : ""}`;
    }
  };

  const getTimeSpansDisplay = (startDateTime, endDateTime) => {
    if (!startDateTime || !endDateTime) return "";

    const startTime = getTimeFromDateTime(startDateTime);
    const endTime = getTimeFromDateTime(endDateTime);

    const duration = getTimeSpans(startDateTime, endDateTime);

    return `${startTime} - ${endTime} (${duration})`;
  };

  const getLinkedInstanceDisplay = (id, name) => {
    if (!id || !name) return "";
    return (
      <TooltipWrapper
        id={`tooltip-linked-instance-${id}`}
        tooltipText={`#${id} - ${name}`}
        tooltipClassName="max-width-by-px-300"
        checkOverflow={true}
      >
        <span className="d-block overflow-hidden text-truncate max-width-by-px-300">{`#${id} - ${name}`}</span>
      </TooltipWrapper>
    );
  };

  return (
    <AccordionItem>
      <AccordionHeader targetId="1" className="mt-0 fw-bold">
        {t("detail.main_section")}
      </AccordionHeader>
      <AccordionBody accordionId="1">
        <FieldDisplay
          label={t(`detail.${FORM_NAME.MAIN.USER_INPUT_ID}`)}
          value={
            <TooltipWrapper
              id="tooltip-sequence-linked-instance"
              tooltipText={sequenceData?.[FORM_NAME.MAIN.LINKED_INSTANCE]}
              tooltipClassName="max-width-by-px-300"
              checkOverflow={true}
            >
              <span className="d-block overflow-hidden text-truncate max-width-by-px-300">
                {sequenceData?.[FORM_NAME.MAIN.LINKED_INSTANCE]}
              </span>
            </TooltipWrapper>
          }
        />

        <EditableField
          label={t(`detail.${FORM_NAME.MAIN.NOTE}`)}
          fieldName={FORM_NAME.MAIN.NOTE}
          value={sequenceData?.[FORM_NAME.MAIN.NOTE]}
          register={register}
          setValue={setValue}
          errors={errors}
          placeholder={t("detail.name_placeholder")}
          isRequired={false}
          maxLengthMessage={t("detail.maxlength")}
          isAllowEdit
        />

        <FieldDisplay
          label={t(`detail.${FORM_NAME.MAIN.LINKED_INSTANCE}`)}
          value={getLinkedInstanceDisplay(
            sequenceData?.yamcs_package?.[FORM_NAME.MAIN.INCREMENT_ID],
            sequenceData?.yamcs_package?.[FORM_NAME.MAIN.NAME]
          )}
        />
        <FieldDisplay label={t(`detail.${FORM_NAME.MAIN.DATA_SOURCE}`)} value={getDataSourceValue(sequenceData)} />
        <FieldDisplay label={t(`detail.${FORM_NAME.MAIN.UPLOAD_TIME}`)} value={sequenceData?.[FORM_NAME.MAIN.UPLOAD_TIME] || ""} />
        <FieldDisplay
          label={t(`detail.${FORM_NAME.MAIN.TIME_SPANS}`)}
          value={getTimeSpansDisplay(sequenceData?.[FORM_NAME.MAIN.START_TIME], sequenceData?.[FORM_NAME.MAIN.END_TIME])}
        />
        <FieldDisplay
          label={t(`detail.${FORM_NAME.MAIN.LAST_EDITOR}`)}
          value={sequenceData?.user_updated_by?.[FORM_NAME.MAIN.NAME] || ""}
        />
      </AccordionBody>
    </AccordionItem>
  );
};

export default MainSection;
